import builder from '../builder';
import Phone from '../../streamline-icons/light/phone.svg';

export default builder('IconPhoneLight', Phone);
